import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
/* Utils */
import { fireSearchLinkTracking } from 'site-modules/shared/utils/inventory/global-search-tracking';
/* Constants */
import {
  GlobalSearchLinkDefaultProps,
  GlobalSearchLinkPropTypes,
} from 'site-modules/shared/constants/global-search/global-search-prop-types';
/* Components */
import { Link } from 'site-modules/shared/components/link/link';

export const GlobalSearchLink = memo(
  ({
    query,
    fastMatcherData,
    creativeId,
    isMobile,
    onLinkClick,
    url,
    selectionType,
    title,
    children,
    rel,
    linkType,
  }) => {
    const handleClick = useCallback(() => {
      fireSearchLinkTracking({
        input: query,
        fastMatcherData,
        value: title,
        selectionType,
        mmtSearchId: fastMatcherData?.trace?.uuid,
        creativeId,
      });
      onLinkClick({ linkType });
    }, [query, fastMatcherData, title, selectionType, creativeId, onLinkClick, linkType]);

    return (
      <Link
        to={url}
        className={classnames('text-decoration-none d-flex w-100 global-search-link py-0_75 rounded-8', {
          'px-0_5': !isMobile,
        })}
        onClick={handleClick}
        rel={rel}
      >
        {children}
      </Link>
    );
  }
);

GlobalSearchLink.displayName = 'GlobalSearchLink';

GlobalSearchLink.propTypes = {
  ...GlobalSearchLinkPropTypes,
  children: PropTypes.node.isRequired,
};

GlobalSearchLink.defaultProps = {
  ...GlobalSearchLinkDefaultProps,
};
